import styled, { css } from 'styled-components'
import { rem, BaseColor, Color, themeColor, transitions, Typography } from '~theme'
import { TagProps, DecorativeTagProps, TagColor } from '~components/Tag/Tag.types'

const SmallTag = css`
  ${Typography.labelMedium};
  ${Typography.textSemiStrong};
  padding: ${rem(3)} ${rem(11)};
`
const MediumTag = css`
  ${Typography.labelLarge};
  ${Typography.textSemiStrong};
  padding: ${rem(5)} ${rem(15)};
`

const InteractiveTag = css`
  color: ${themeColor(BaseColor.shade_60)};
  border-color: ${themeColor(BaseColor.shade_40)};

  &:hover,
  &:focus-visible {
    color: ${themeColor(BaseColor.shade_70)};
    background: ${themeColor(BaseColor.shade_20)};
    border-color: ${themeColor(BaseColor.shade_50)};
  }

  &:active {
    border-color: ${themeColor(BaseColor.shade_60)};
  }
`

const ActiveInteractiveTag = css`
  color: ${themeColor(BaseColor.shade_10)};
  background: ${themeColor(BaseColor.shade_60)};
  border-color: ${themeColor(BaseColor.shade_60)};

  &:hover,
  &:focus-visible {
    background: ${themeColor(BaseColor.shade_70)};
    border-color: ${themeColor(BaseColor.shade_70)};
  }

  &:active {
    border-color: ${themeColor(BaseColor.shade_50)};
  }
`

export const Tag = styled('span')<TagProps>`
  display: inline-block;
  border-radius: 9999px;
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;

  ${transitions(['background-color', 'border-color', 'color'])}

  ${props => (props?.size === 'medium' ? MediumTag : SmallTag)};
  ${props => (props?.active ? ActiveInteractiveTag : InteractiveTag)};
`

const staticColor = (c?: TagColor) => {
  switch (c) {
    case 'warning':
      return themeColor(Color.warning)
    case 'info':
      return themeColor(Color.info)
    case 'base':
    default:
      return themeColor(BaseColor.shade_50)
  }
}

export const DecorativeTag = styled('span')<DecorativeTagProps>`
  display: inline-block;
  border-radius: 9999px;
  user-select: none;

  ${props => (props?.size === 'medium' ? MediumTag : SmallTag)};

  color: ${props => staticColor(props.color)};
  border: 1px solid ${props => staticColor(props.color)};
`
